import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"
import G from "../../utils/SvgGroup"

const GoogleIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-5.4 0 26 15.4"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <Path d="m0 0h16v16h-16z" />
      </clipPath>
      <G clip-path="url(#a)" clip-rule="evenodd" fill-rule="evenodd">
        <Path
          fill={color}
          d="m15.68 8.18129c0-.56728-.0509-1.11273-.1455-1.63637h-7.5345v3.09455h4.3055c-.1855 1.00003-.7491 1.84723-1.5964 2.41453v2.0073h2.5854c1.5128-1.3927 2.3855-3.4437 2.3855-5.88001z"
        />
        <Path
          fill={color}
          d="m8.00065 15.9995c2.16005 0 3.97095-.7163 5.29455-1.9382l-2.5855-2.0072c-.71632.48-1.63268.7636-2.70905.7636-2.08363 0-3.84727-1.4073-4.47636-3.29817h-2.672728v2.07277c1.316368 2.6145 4.021818 4.4072 7.149088 4.4072z"
        />
        <Path
          fill={color}
          d="m3.52364 9.52093c-.16-.48-.25091-.99273-.25091-1.52s.09091-1.04.25091-1.52v-2.07273h-2.672731c-.541818 1.08-.850909 2.30182-.850909 3.59273s.309091 2.51277.850909 3.59277z"
        />
        <Path
          fill={color}
          d="m8.00065 3.18182c1.17455 0 2.22905.40363 3.05815 1.19636l2.2946-2.29454c-1.3855-1.290913-3.1964-2.08364-5.35275-2.08364-3.12727 0-5.83272 1.79273-7.149088 4.40727l2.672728 2.07273c.62909-1.89091 2.39273-3.29818 4.47636-3.29818z"
        />
      </G>
    </Svg>
  )
}

export default GoogleIconSvg
